export default __webpack_public_path__ + "static/media/environmental-impact-light.67209398.png";